import {$window, $body} from '../../../../../../ig_template/Resources/Public/Src/Js/Constants';
import SwiperSlider from '../../../../../../ig_template/Resources/Public/Src/Js/Elements/SwiperSlider';

/**
 * Accessory Image Slider Slider
 */
const AccessoryImageSlider = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		ACCESSORY_IMAGE_SLIDER: '.swiper-container.accessory-image-slider',
	};

	/**
	 * Accessory Image Slider
	 *
	 * @class
	 * @augments SwiperSlider
	 */
	class AccessoryImageSlider extends SwiperSlider {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this.setOptions({
				slidesPerView: 1,
				grabCursor: false,
				pagination: {
					el: this.constructor.Selector.PAGINATION,
					clickable: true
				},
				autoplay: {
					delay: 5000,
					disableOnInteraction: false
				}
			});

			if (this.slider === null) {
				this._initialize();
			}
		}
	}

	return AccessoryImageSlider;
})();

export default AccessoryImageSlider;
